import React, { FC, ReactElement } from 'react';

import styles from './styles.module.scss';

import type { ITableRow } from 'types/interfaces';

export const TableHeader: FC<ITableRow> = ({ children }: ITableRow): ReactElement => (
    <div className={styles.tableHeader}>{children}</div>
);
